module.exports = "/_next/static/images/f69d2d98af11658f4d55aa07250efee8-man-holding-device-2@0.75x.jpg.webp";